import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllNotAcquiredUserVideos, StateStatus } from '@guryou/redux';

const useUserNotAcquiredVideos = ({ userId, silent }) => {
  const dispatch = useDispatch();

  const { data, status, version, entity, request } = useSelector(state => state.videos.userNotAcquiredVideos);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED || (status === StateStatus.LOADED && +request?.userId !== +userId)) {
      dispatch(getAllNotAcquiredUserVideos(+userId, silent));
    }
  }, [dispatch, userId, request, silent, status]);

  if (!userId) {
    return { data: null, status: StateStatus.NOT_INITIALIZED };
  }

  return { data: data || [], status, version, entity };
};

export default useUserNotAcquiredVideos;
